function FeeStructure() {
  return (
    <div style={{ padding: '20px' }}>
      <h1 className="text-2xl font-bold text-center mb-4">Fees Structure 2025-26</h1>
      <p className="text-center mt-4">
        <a
          href="/documents/Fees-Structure-2025-26.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xl font-bold text-purple-700 underline hover:text-purple-900"
        >
          CLICK HERE TO SEE FEE STRUCTURE
        </a>
      </p>
    </div>
  );
  }
  export default FeeStructure;
  